import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export const quoteInitialValues = (subSection: SubSection) => ({
  title: subSection?.title || "",
  text: subSection.attrs.text, // Optional
  author: subSection.attrs.author,
});

export const quoteValidationSchema = Yup.object({
  text: Yup.string().required("Text is required"),
  author: Yup.string().required("Author is required"),
});
